import { RootState } from "../../store";

export const selectOrgStructure = (state: RootState) => state.orgStructure;